module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"reviews_count":"評論","product_score":"評分"}}')
  delete Component.options._Ctor
}
